<scitis-app-global-page-header [pageTitle]="'Services'">
</scitis-app-global-page-header>

<div class="row">
  @for (connector of connectors; track connector) {
    <div class="col-12 col-lg-4 mb-3">
      <div class="card card-default h-100">
        <div class="card-header h5">
          <div class="row align-items-center">
            <div class="col">
              <span [ngClass]="getStatusClass(connector)" class="status status-success"></span>
              <span class="h5" [innerText]="connector.name"></span>
            </div>
            <div class="col-auto">
              @if (spin(connector)) {
                <em class="fa-solid fa-spinner fa-spin"></em>
              }
              @if (displayIbaConfigButton(connector)) {
                <button class="btn btn-outline-primary btn-xs" (click)="openIbaConfig()" aria-hidden="true"
                  >
                  <span class="fa-solid fa-pen"></span>
                </button>
              }
            </div>
          </div>
        </div>
        <div class="card-body">
          @if (!connector.enabled) {
            <button (click)="onToggleConnectorStatus(connector)"
              [disabled]="buttonIsDisabled(connector)"
              class="btn btn-block btn-primary">
              <span class="ng-scope" translate>Activate</span>
            </button>
          }
          @if (connector.enabled) {
            <button (click)="onToggleConnectorStatus(connector)"
              [disabled]="buttonIsDisabled(connector)"
              class="btn btn-block btn-primary">
              <span class="ng-scope" translate>Deactivate</span>
            </button>
          }
        </div>
      </div>
    </div>
  }

</div>
